<mat-form-field
    subscriptSizing="dynamic"
    [class.st-text-area--required]="required() && !internalValue()">
    @if (label()) {
        <mat-label>
            {{ label() }}
        </mat-label>
    }
    <div
        #display
        st-click-stop-propagation
        class="st-text-area__display"
        [class.st-text-area__display--edit]="inEditMode()"
        [innerHTML]="displayValue() | linky: { stripPrefix: false } | highlight: textToHighlight() : false | unsafe: 'html'"></div>
    <textarea
        #control
        matInput
        cdkTextareaAutosize
        [class.st-text-area__input--edit]="!inEditMode()"
        [ngModel]="internalValue()"
        [required]="required()"
        [disabled]="disabled()"
        [placeholder]="displayPlaceholder()"
        [cdkAutosizeMaxRows]="15"
        [maxLength]="maxLength()"
        (scroll)="onScroll($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (change)="onValueChanged()"
        (ngModelChange)="onNgModelChanged($event)"></textarea>
    @if (hint()) {
        <mat-hint>{{ hint() }}</mat-hint>
    }
    @if (hasSuffix()) {
        <ng-container matSuffix>
            <ng-content select="[suffix]" />
        </ng-container>
    }
    @if (hasPrefix()) {
        <ng-container matPrefix>
            <ng-content select="[prefix]" />
        </ng-container>
    }
    @if (hasError()) {
        <ng-container matError>
            <ng-content select="[error]" />
        </ng-container>
    }
</mat-form-field>
